/**
 * @override King Living: Header 2.0 category fetch.
 * Nested columns are links-only (NavigationColumnFragment). Do not nest
 * menuImageGallery here. L3 is GetNavLinkGalleryById on hover (one Link).
 * Do not spread generated LinkFragment. Header 1.0 must not use this fragment.
 */

import gql from 'graphql-tag';

import {BaseMenuItemFragment} from '@amblique/contentful/app/contentful/fragments/menu-item/base-menu-item.fragment';
import {BaseImageFragment} from '@amblique/king-living/app/contentful/fragments/image/base-image.fragment';
import {BaseLinkFragment} from '@amblique/king-living/app/contentful/fragments/link/base-link.fragment';
import {NavigationColumnFragment} from '@amblique/king-living/app/contentful/fragments/navigation-column/navigation-column.fragment';

export const FullMenuItemFragment = gql`
  ${BaseMenuItemFragment}
  ${BaseImageFragment}
  ${BaseLinkFragment}
  ${NavigationColumnFragment}

  fragment FullMenuItemFragment on MenuItem {
    ...BaseMenuItemFragment

    featuredLink {
      ...BaseLinkFragment
    }
    imagesCollection {
      items {
        __typename
        ... on Image {
          ...BaseImageFragment
        }
      }
    }
    link {
      ...BaseLinkFragment
    }
    submenuCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...NavigationColumnFragment
        }
      }
    }
    submenuCursorCollection {
      items {
        __typename
        ... on NavigationColumn {
          ...NavigationColumnFragment
        }
      }
    }
  }
`;
